<div class="modals__container">
  <div class="modals__header">
    <img
    mfpLazyImage
      class="modals__close"
      lazySrc="assets/icons/close.svg"
      (click)="onCloseModal()"
    />
  </div>
  <div class="share">
    <h1 class="share__title">{{ 'SHARE.TITLE' | translate }}</h1>
    <form
      [formGroup]="shareForm"
      (ngSubmit)="onSendForm()"
    >
      <div class="share__container mfp-white-box">
        <div class="row">
          <div class="col-xs-24 col-sm-14 col-gutter-lr">
            <mfp-input
              formControlName="email"
              name="email"
              type="text"
              [label]="'SHARE.EMAIL' | translate"
              [placeholder]="'SHARE.EMAIL_PLACEHOLDER' | translate"
              [required]="true"
              [readonly]="false"
              [success]="isFieldValid(shareForm, 'email')"
              [error]="isFieldInvalid(shareForm, 'email')"
              [helper]="getFieldError(shareForm, 'email') | translate"
            ></mfp-input>
          </div>
        </div>
      </div>
      <div class="share__actions">
        <mfp-button
          type="button"
          color="primary"
          fill="outline"
          [label]="'CANCEL' | translate"
          [disabled]="false"
          (click)="onCloseModal()"
        ></mfp-button>
        <mfp-button
          class="share__actions-save"
          type="submit"
          color="primary"
          fill="default"
          [label]="'SEND' | translate"
          [disabled]="shareForm.invalid"
        ></mfp-button>
      </div>
    </form>
  </div>
</div>
